export enum Insurance {
  DIMC = 'DIMC',
  DIM = 'DIM',
  D = 'D',
  NONE = '0',
}

export interface InsuranceModel {
  code: string;
  label: string;
  monthlyPaymentInsuranceCost?: number;
  taea?: number;
  totalCostInsurance?: number;
  warranties: Warranty[];
  higher?: boolean;
}

export interface Warranty {
  label: string;
  description: string;
}

export const insuranceByCode = (code: string): InsuranceModel | undefined => {
  return steps.find((asm) => asm.code === code);
};

export const steps: InsuranceModel[] = [
  {
    code: Insurance.DIMC,
    label: 'Décès, Invalidité, Maladie, Chômage',
    warranties: [
      { label: 'Décès', description: "L'assureur règle le solde de votre crédit à la date du décès.⁽¹⁾" },
      {
        label: 'Invalidité',
        description:
          'L’assureur règle le solde de votre crédit à la date de constatation médicale de la Perte Totale et Irréversible d’Autonomie.⁽¹⁾',
      },
      {
        label: 'Maladie ou accident',
        description:
          'En cas d’Incapacité Temporaire Totale de Travail, l’assureur prend en charge vos mensualités pendant 18 mois maximum, à l’expiration d’un délai de franchise de 90 jours.⁽¹⁾',
      },
      {
        label: 'Chômage',
        description:
          'En cas de Perte d’Emploi suite à un licenciement, l’assureur prend en charge vos mensualités pendant 18 mois maximum, à l’expiration d’un délai de franchise de 90 jours.⁽¹⁾ Les 180 jours suivant l’adhésion ne sont pas couverts.',
      },
    ],
  },
  {
    code: Insurance.DIM,
    label: 'Décès, Invalidité, Maladie',
    warranties: [
      { label: 'Décès', description: "L'assureur règle le solde de votre crédit à la date du décès.⁽¹⁾" },
      {
        label: 'Invalidité',
        description:
          'L’assureur règle le solde de votre crédit à la date de constatation médicale de la Perte Totale et Irréversible d’Autonomie.⁽¹⁾',
      },
      {
        label: 'Maladie ou accident',
        description:
          'En cas d’Incapacité Temporaire Totale de Travail, l’assureur prend en charge vos mensualités pendant 18 mois maximum, à l’expiration d’un délai de franchise de 90 jours.⁽¹⁾',
      },
    ],
  },
  {
    code: Insurance.D,
    label: 'Décès',
    warranties: [{ label: 'Décès', description: "L'assureur règle le solde de votre crédit à la date du décès." }],
  },
  {
    code: Insurance.NONE,
    label: 'Sans Assurance',
    warranties: [
      { label: 'Décès', description: "L'assureur règle le solde de votre crédit à la date du décès." },
      { label: 'Invalidité', description: "L'assureur règle le solde de votre crédit à la date du décès." },
      { label: 'Maladie ou accident', description: "L'assureur règle le solde de votre crédit à la date du décès." },
      { label: 'Chomage', description: "L'assureur règle le solde de votre crédit à la date du décès." },
    ],
  },
];
